import { render, staticRenderFns } from "./rewardOnePlusSixCollectEdit.vue?vue&type=template&id=63185e84&scoped=true&"
import script from "./rewardOnePlusSixCollectEdit.vue?vue&type=script&lang=js&"
export * from "./rewardOnePlusSixCollectEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63185e84",
  null
  
)

export default component.exports